



function byBilet(){
    FS('.by-bilet').addUniqueClass('filter-select-item--selected');
    FS('.test-by-bilet').show('flex');
    FS('.test-by-tema').hide();

}
function byTema(){
    FS('.by-tema').addUniqueClass('filter-select-item--selected');
    FS('.test-by-bilet').hide();
    FS('.test-by-tema').show('flex');
}